import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import http from '@/utils/http';
import { ElLoading } from 'element-plus';
import { message } from '@/utils/restMessage.js';
export default {
  data: function data() {
    return {
      name: '',
      //报名人员
      pmkd: '100%',
      index: '',
      //用于判断是什么类型
      grData: [],
      //个人数据
      status: '',
      //状态值，用来判断是外部还是内部
      bwidth: true,
      //表单宽度
      imgStatus: false,
      //图片状态
      titleSize: 24,
      //标题大小
      mainpadding: 20,
      //整体边距
      phoneShow: true,
      orderData: [],
      //页面表格数据
      // 要传递的数据
      bus: {
        id: '',
        name: '',
        scsh: '',
        yf: '',
        xssc: '',
        fz: '',
        dialogFormVisible: false
      },
      //报名数据
      pagings: {
        pageNumber: 1,
        // 当前第几页
        pageSize: 30,
        // 当前页多少条
        total: 0,
        // 总数
        queryObj: {}
      }
    };
  },
  created: function created() {
    // this.cs()
    this.fo();
    this.status = this.$route.query.status;
    console.log(this.status, '当前状态值');
    console.log(window.screen.availWidth, '当前屏幕宽度');
    this.grData = this.$store.state.power.data;
    console.log(this.$store.state.power.data, '个人数据');

    if (window.screen.availWidth < 800) {
      //判断屏幕小于800时
      this.pmkd = window.screen.availWidth - 30 + 'px';
      console.log(this.pmkd, '处理后的宽度');
      this.titleSize = 17;
      this.mainpadding = 0;
      this.bwidth = false;
      this.phoneShow = false;
    }
  },
  methods: {
    // 测试数据
    cs: function cs() {
      http.get("/MicroServiceMLBAuto/mlbinterface.do?c=GET_BARCODE_PRE_DISTRIBUTE&carrier_station=SMT_INPUT2&info_type=JIG&jig_station=SMT_INPUT&line_name=LINE&numGroups=0&result=.*N&upload_info=JIGSN").then(function (res) {
        var _res$data = res.data,
            code = _res$data.code,
            description = _res$data.description,
            data = _res$data.data;
        console.log(res, '测试数据');
        return;

        if (200 == code) {
          message({
            type: 'success',
            message: '报名成功!'
          });
        } else {
          message({
            type: 'error',
            message: description
          });
        }
      }).catch(function () {
        ElMessage({
          type: 'error',
          message: '后台错误请联系管理员！'
        });
      });
    },
    // 点击报名
    sign: function sign(value, index, name) {
      var _this = this;

      console.log(value, '报名数据');
      this.bus = {
        id: '',
        name: '',
        scsh: '',
        yf: '',
        xssc: '',
        fz: ''
      };
      Object.assign(this.bus, value);
      this.bus.dialogFormVisible = true;
      return;
      this.name = name;
      this.bus.id = value.id;
      this.index = index;

      if (this.status == 1) {
        ElMessageBox.confirm('确定报名?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this.baomin(value);
        }).catch(function () {
          ElMessage({
            type: 'info',
            message: '已取消'
          });
        });
      } else {
        this.bus.dialogFormVisible = true;
      }
    },
    // 判断是否重复
    chongfu: function chongfu(data) {
      var sun = data ? data.split(',') : '';
      var sun1 = sun.indexOf(this.bus.name);

      if (sun1 != -1) {
        ElMessage({
          type: 'error',
          message: '请勿重复报名！'
        });
        return false;
      }

      return sun1 != -1 ? false : true;
    },
    baomin: function baomin(value) {
      var _this2 = this;

      if (this.status) {
        // console.log('状态为真');
        // let { lastname } = this.grData
        // if (this.index == 1) {
        //     this.bus.scsh = lastname
        // } else if (this.index == 2) {
        //     this.bus.yf = lastname
        // } else {
        //     if(this.name){//判断是否有人员
        //         this.bus.xssc = this.name+','+lastname
        //     }else{
        //         this.bus.xssc = lastname
        //     }
        //     console.log(this.bus.xssc,'处理后的人员数据');
        // }
        http.post("/ksfproductsubmit/update", this.bus).then(function (res) {
          var _res$data2 = res.data,
              code = _res$data2.code,
              description = _res$data2.description,
              data = _res$data2.data;

          if (200 == code) {
            message({
              type: 'success',
              message: '报名成功!'
            });

            for (var key in _this2.bus) {
              _this2.bus[key] = '';
            }

            _this2.bus.dialogFormVisible = false;

            _this2.fo();
          } else {
            message({
              type: 'error',
              message: description
            });
          }
        }).catch(function () {
          ElMessage({
            type: 'error',
            message: '后台错误请联系管理员！'
          });
        });
      } else {
        if (this.bus.name == '') {
          ElMessage({
            type: 'error',
            message: '姓名不能为空'
          });
          return false;
        } // const regex = /^[\u4e00-\u9fa5]{2,4}$/; // 匹配2至4个中文字符的姓名
        // let xm = regex.test(this.bus.name);
        // console.log(xm, '姓名状态值',this.bus.fz);
        // if (!xm) {
        //     ElMessage({
        //         type: 'error',
        //         message: '请填写正确的姓名',
        //     })
        //     return false
        // }


        if (!this.bus.fz) {
          ElMessage({
            type: 'error',
            message: '请选择你的分组'
          });
          return false;
        }

        var fz = this.bus.fz;

        if (fz == 1) {
          //工程/售后
          if (!this.chongfu(this.bus.scsh)) {
            console.log('重复1');
            return false;
          }

          this.bus.scsh = this.bus.scsh ? this.bus.scsh + ',' + this.bus.name : this.bus.name;
        } else if (fz == 2) {
          //研发
          if (!this.chongfu(this.bus.yf)) {
            console.log('重复2');
            return false;
          }

          this.bus.yf = this.bus.yf ? this.bus.yf + ',' + this.bus.name : this.bus.name;
        } else {
          //销售/市场
          if (!this.chongfu(this.bus.xssc)) {
            console.log('重复3');
            return false;
          }

          this.bus.xssc = this.bus.xssc ? this.bus.xssc + ',' + this.bus.name : this.bus.name;
        }

        http.post("/ksfproductsubmit/update", this.bus).then(function (res) {
          var _res$data3 = res.data,
              code = _res$data3.code,
              description = _res$data3.description,
              data = _res$data3.data;

          if (200 == code) {
            message({
              type: 'success',
              message: '报名成功!'
            });

            for (var key in _this2.bus) {
              _this2.bus[key] = '';
            }

            _this2.bus.dialogFormVisible = false;

            _this2.fo();
          } else {
            message({
              type: 'error',
              message: description
            });
          }
        }).catch(function () {
          ElMessage({
            type: 'error',
            message: '后台错误请联系管理员！'
          });
        });
      }
    },
    // 报名数据
    fo: function fo() {
      var _this3 = this;

      http.post("/ksfproductsubmit/page/search", this.pagings).then(function (res) {
        var _res$data4 = res.data,
            code = _res$data4.code,
            description = _res$data4.description,
            data = _res$data4.data;
        console.log(res, '报名数据');

        if (200 == code) {
          _this3.orderData = data.rows;
        } else {
          message({
            type: "error",
            message: description
          });
        }
      });
    }
  }
};